module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_showroom-small-46f5b5640e5663d8d4fb7a1039ead3ef.jpg";